module.exports = __webpack_public_path__ + "static/img/JAMES_FAULKNER.1792f73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JAMES_FAULKNER.jpg
// module id = HPoE
// module chunks = 0